module.exports = __webpack_public_path__ + "img/button_02pc.a5217a6e.webp";